export const parseApiError = (error) => {
  if (error.response && error.response.data && error.response.data.message) {
    return new Error(error.response.data.message);
  }

  if (error.message) {
    return new Error(error.message);
  }

  return new Error('No se pudo completar la solicitud.');
};

export const getApiData = (response, fallbackMessage) => {
  if (!response.data || !response.data.ok) {
    throw new Error((response.data && response.data.message) || fallbackMessage);
  }

  return response.data.data;
};
